// src/components/Admin/VirtualScenes/VirtualScenes.js
import React, { useState } from "react";
import { Tab, Button } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { SceneList, MultiStepForm } from "../../../../components/Admin/VirtualScenes";
import "./VirtualScenes.scss";

export function VirtualScenes() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prev) => !prev);
  const onReload = () => setReload((prev) => !prev);

  // Pasos de Educamaker
  const steps = [
    {
      title: "Paso 1",
      desc:
        'En esta página podrás añadir Clases creadas externamente desde "Agregar Escena", aportando los datos y URL de acceso a la sala. Puedes crearlas desde Educamaker pulsando en "Educamaker" o subir cualquier enlace externo.',
    },
    {
      title: "Paso 2",
      desc:
        'Una vez creadas, las verás aquí y se listarán en el filtro de "otros" en la pestaña "Crear itinerarios", donde podrás añadir la nueva Sala a tu Itinerario Formativo.',
    },
    {
      title: "Paso 3",
      desc:
        'También encontrarás opciones de edición y ver la nueva sala una vez creada.',
    },
  ];

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <SceneList reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  // Abrir Educamaker en nueva pestaña
  const handleOpenEducamaker = () => {
    window.open(
      "https://educa360.org/spoke/projects",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      <div className="virtual-scenes-page">
        {/* Pasos encima de los botones */}
        <div className="virtual-scenes-page__steps">
          {steps.map((s, i) => (
            <div key={i} className="intro-section step">
              <h2 className="intro-title">{s.title}</h2>
              <p className="intro-description">{s.desc}</p>
              <hr className="intro-divider" />
            </div>
          ))}
        </div>

        <div className="virtual-scenes-page__buttons">
          <Button
            className="virtual-scenes-page__button"
            onClick={handleOpenEducamaker}
          >
            Educamaker
          </Button>
          <Button
            primary
            className="virtual-scenes-page__button"
            onClick={onOpenCloseModal}
          >
            Agregar Escena
          </Button>
        </div>

        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear nueva escena virtual"
      >
        <MultiStepForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
